import { AudioWaveform } from "../audio-waveform";
import { useChatForm } from "./use-chat-form";

export const ChatFormAudioWaveform = () => {
  const { audioLevels } = useChatForm();

  return (
    <div className="px-1">
      <AudioWaveform levels={audioLevels} numBars={5} maxHeight={12} barClassName="bg-muted-foreground" />
    </div>
  );
};
